import { render } from "./FormInfo.vue?vue&type=template&id=0dfe2388"
import script from "./FormInfo.vue?vue&type=script&lang=js"
export * from "./FormInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__